<template>
  <div>
    <!-- <div class="container pl-4 pr-4">
      <h1 class="title mb-5">Hotelkarte</h1>
    </div> -->

    <GmapMap class="hotelmap" v-if="lat && lon" ref="mapRef" :center="{lat: lat, lng: lon}" :zoom="zoomLevel" map-type-id="roadmap">
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen = false">
        <router-link
          v-if="selectedMarker"
          :to="{
            name: 'hotel-overview',
            params: {
              contact: selectedMarker.slug,
            },
          }"
          ><strong>{{ selectedMarker.name }}</strong
          ><br />{{ selectedMarker.address }}<br />{{ selectedMarker.country }}-{{ selectedMarker.zip }} {{ selectedMarker.city }}
        </router-link>
      </gmap-info-window>
      <GmapMarker v-for="position in positions" :key="position.data.id" :position="position" :clickable="true" :draggable="false" @click="toggleInfoWindow(position)" />
    </GmapMap>
  </div>
</template>

<script>
import store from '../_store'
import hotelApi from '@/api/hotel-api'
export default {
  name: 'MapView',
  components: {},
  data() {
    return {
      loaded: false,
      lat: 46.6364124717809,
      lon: 12.69145909374998,
      positions: [],
      hotels: [],
      zoomLevel: 5, // europe
      selectedMarker: null,
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    }
  },
  computed: {
    marker() {
      return {
        position: {
          lat: this.lat,
          lng: this.lon,
        },
      }
    },
  },
  created() {
    const STORE_KEY = '$_hotel'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  async mounted() {
    const hotels = await hotelApi.getHotelsInRadius(this.lat, this.lon, 8566)

    console.log('hotels', hotels)

    console.log(hotels.filter(x => x.searchResults.length > 0))

    this.positions = hotels
      .filter(f => f.geoCoordinate && f.geoCoordinate.latitude != 0 && f.geoCoordinate.longitude != 0)
      .filter(f => {
        if (this.$whitelabel.activeOffersOnly) {
          return f.searchResults.length > 0
        } else {
          return f
        }
      })
      .map(f => {
        return {lat: f.geoCoordinate.latitude, lng: f.geoCoordinate.longitude, data: f}
      })
    const debounce = (fn, time) => {
      let timeout
      return () => {
        const args = arguments
        const functionCall = () => fn.apply(this, args)
        clearTimeout(timeout)
        timeout = setTimeout(functionCall, time)
      }
    }
    //TODO: decide where to center intially
    //pan map to avaiable markers
    //for now we just show europe
    this.$refs.mapRef.$mapPromise.then(map => {
      //thorttle fix http://code.google.com/p/gmaps-api-issues/issues/detail?id=1371
      map.addListener(map, 'idle', function() {})
      map.addListener(
        'bounds_changed',
        debounce(async () => {
          const metersPerPx = (156543.03392 * Math.cos((map.center.lat() * Math.PI) / 180)) / Math.pow(2, map.zoom)
          const widthInPixel = map.getDiv().offsetWidth
          const radius = Math.round((widthInPixel * metersPerPx) / 1000 + 1)
          const hotels = await hotelApi.getHotelsInRadius(map.center.lat(), map.center.lng(), radius)
          this.positions = hotels.map(f => {
            return {lat: f.geoCoordinate.latitude, lng: f.geoCoordinate.longitude, data: f}
          })
        }, 1500),
      )
    })
  },

  methods: {
    toggleInfoWindow(marker) {
      this.selectedMarker = marker.data
      this.infoWindowPos = marker
      // this.infoOptions.content = `<router-link :to=" name: 'hotel-overview',
      //     params: {
      //       slug: '${marker.data.slug}',
      //     },"><strong>${marker.data.name}</strong><br>${marker.data.address}<br>${marker.data.country}-${marker.data.zip} ${marker.data.city}</router-link>`
      this.infoWinOpen = !this.infoWinOpen
    },
  },
  metaInfo() {
    const title = 'Hotel'
    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: `Alle Angebote für Hotel`,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.hotelmap {
  height: calc(100vh - 5.5rem);
  margin-top: -1.7rem;

  @media screen and (min-width: 480px) {
    margin-top: -0.7rem;
  }
}
</style>
